import React, { lazy, Suspense } from 'react'
import { useAccessToken } from '@chilecompra/react-kit'
import { Breadcrumb, Breadcrumbs } from '@chilecompra/react-kit/components'
import { REACT_APP_PROVIDERS_BASE_URL, REACT_APP_FEATURE_FLAG_HABILITY_STATUS } from '../config/settings/environment'
import BrandLayout from '../components/Layouts/BrandLayout'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import AuthorizationProviderContext from '../containers/AuthorizationProvider/AuthorizationProvider.context'
import ConfigProviderContainer from '../containers/ConfigProvider/ConfigProvider.container'
import NewQuoteAccessContainer from '../containers/NewQuoteAccess/NewQuoteAccess.container'
import OnboardingDialogContainer from '../containers/OnboardingDialog/OnboardingDialog.container'
import ProtectByProfile from '../components/Security/ProtectByProfile'
import QuoteSearchHeadingFiltersContainer from '../containers/QuoteSearchHeadingFilter/QuoteSearchHeadingFilters.container'
import QuoteSearchFiltersContainer from '../containers/QuoteSearchFilters/QuoteSearchFilters.container'
import QuoteSearchResultsContainer from '../containers/QuoteSearchResults/QuoteSearchResults.container'
import QuoteSearchResumeContainer from '../containers/QuoteSearchResume/QuoteSearchResume.container'
import PurchaseOrderChangeStatusDialog from '../containers/PurchaseOrderChangeStatusDialog/PurchaseOrderChangeStatusDialog.container'
import { Link, SearchGridLayout, Toast } from './QuoteSearch.styles'
import QuoteNotification from '../containers/QuoteNotification/QuoteNotification.container'
import QuoteNotificationBottom from '../containers/QuoteNotificationBottom/QuoteNotificationBottom.container'
import NotFoundPage from './NotFound'

const ForcedEMTDIalog = lazy(() => import('../containers/ForcedEMTDialog/ForcedEMTDialog.container'))

/*
 * The Quote Search's page
 */
const QuoteSearch = () => {
  const accessToken = useAccessToken()

  const changeToMyCompany = `${REACT_APP_PROVIDERS_BASE_URL}/mi-empresa/historial-pagos?t=${accessToken}`
  const showBanner = REACT_APP_FEATURE_FLAG_HABILITY_STATUS !== 'false'

  return (
    <AuthorizationProviderContainer>
      <AuthorizationProviderContext.Consumer>
        {({ isBuyer, isSeller }) => (
          <ProtectByProfile
            rule={userType => userType === 'Comprador' || userType === 'Proveedor'}
            fallback={() => <NotFoundPage />}
          >
            <ConfigProviderContainer>
              <BrandLayout>
                {showBanner && (
                  <ProtectByProfile rule={userType => userType === 'Proveedor'}>
                    <Toast severity="warning" margin="0 0 40px 0">
                      Próximamente, será requisito indispensable que los proveedores se encuentren en{' '}
                      <strong>
                        estado hábil en el Registro de Proveedores para enviar sus cotizaciones en Compra Ágil en
                        Mercado Público
                      </strong>
                      . Asegúrate de que la información de tu empresa se encuentre al día obteniendo tu estado de
                      habilidad desde el menú
                      <Link target="_top" href={changeToMyCompany}>
                        {' '}
                        Mi Empresa
                      </Link>
                      .
                    </Toast>
                  </ProtectByProfile>
                )}
                <Breadcrumbs>
                  <Breadcrumb>Escritorio</Breadcrumb>
                  <Breadcrumb>Compra Ágil</Breadcrumb>
                </Breadcrumbs>
                <QuoteNotification />
                <SearchGridLayout isBuyer={isBuyer} isSeller={isSeller}>
                  <QuoteSearchHeadingFiltersContainer />
                  <ProtectByProfile rule={userType => userType === 'Comprador'}>
                    <NewQuoteAccessContainer />
                  </ProtectByProfile>
                  <QuoteNotificationBottom />
                  <QuoteSearchResumeContainer />
                  <QuoteSearchFiltersContainer />
                  <QuoteSearchResultsContainer />
                </SearchGridLayout>
                <PurchaseOrderChangeStatusDialog />
                <OnboardingDialogContainer />
              </BrandLayout>
            </ConfigProviderContainer>
            <Suspense>
              <ProtectByProfile rule={userType => userType === 'Proveedor'}>
                <ForcedEMTDIalog />
              </ProtectByProfile>
            </Suspense>
          </ProtectByProfile>
        )}
      </AuthorizationProviderContext.Consumer>
    </AuthorizationProviderContainer>
  )
}

export default QuoteSearch
